import React, {useContext} from "react";
import {RootControllersContext} from "../../../../../controllers/root/root.controllers";

interface RenderImgProps {
    src?: string;
    alt?: string;
}

export const RenderImg: React.FC<RenderImgProps> = ({src, alt}) => {

    const {loginController} = useContext(RootControllersContext)

    return <img
        alt={alt}
        src={loginController.generateUri(src || "")}
    />
}